<template>
  <div id="footer" class="container-fluid">
    <!-- <div class="logo"> -->
      <!-- <img src="@/assets/img/logo_lianmeng.png" alt="logo图"> -->
    <!-- </div> -->
    <p class="title" style="margin-top: 20px;">装饰辅材行业联盟</p>
    <p class="address_tel_fax">
      <span>地址：河北省石家庄市裕华区中冶盛世广场C座</span>
      <span>联盟联系电话：17332381888</span>
      <!-- <span>邮箱：8888-88888888</span> -->
    </p>
<!--    <p class="email_wx">
      <span>邮箱：bx@yunbird.cn</span>
      <span>公司微信号：19833102171</span>
    </p> -->
    <p class="copy">Copyright &copy;2024<a href="https://beian.miit.gov.cn/ " target="_blank'">冀ICP备2022023853号-5</a>   石家庄云鸟快采科技有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 20px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue